"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.serializeError = exports.logErrorObj = exports.logObj = exports.log = exports.logError = exports.logBatch = void 0;
var tslib_1 = require("tslib");
var sendMetric_1 = require("./lib/sendMetric");
var lodash_1 = tslib_1.__importDefault(require("lodash"));
var api_1 = tslib_1.__importDefault(require("./api"));
/**
 * @param {[title?: string, severity?: string, message?: string, source?: string, description?: string][]} logsData
 * - array containing all the logs info.
 */
function logBatch(logsData) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var payload;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    payload = logsData.map(function (element) {
                        var _a = tslib_1.__read(element, 5), _b = _a[0], title = _b === void 0 ? window.location.hostname : _b, _c = _a[1], severity = _c === void 0 ? 'info' : _c, message = _a[2], _d = _a[3], source = _d === void 0 ? window.location.pathname : _d, description = _a[4];
                        return {
                            title: title,
                            source: source,
                            severity: severity,
                            message: message,
                            description: description,
                        };
                    });
                    return [4 /*yield*/, api_1.default.post('/api/logging', payload).catch(function (error) {
                            console.error(error);
                        })];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
exports.logBatch = logBatch;
/**
 * @param {Error} error - The error object
 * @param {string} title - A title for the log
 * @param {string} [message] -
 * @param {string} [source] -
 * @param {string} [description] -
 */
function logError(error, title, message, source, description) {
    if (message === void 0) { message = error.message; }
    if (description === void 0) { description = serializeError(error); }
    (0, exports.log)(title, 'error', message, source, description);
}
exports.logError = logError;
/**
 * @type {(title: string, severity: string, message?: string, source?: string, description?: string) => void}
 * - the title and severity of the log are required the remaining parameters are optional
 */
exports.log = (0, sendMetric_1.debounceWithQueue)(function (args) { return module.exports.logBatch(args); }, 100);
/**
 *
 * @param {{title: string, severity: string, message?: string, source?: string, description?: string}} objArgs
 * @returns
 */
function logObj(objArgs) {
    return (0, exports.log)(objArgs.title, objArgs.severity, objArgs.message, objArgs.source, objArgs.description);
}
exports.logObj = logObj;
/**
 *
 * @param {Error} error
 * @param {{title?: string, message?: string, source?: string, description?: string}} [objArgs = {}]
 * @returns
 */
function logErrorObj(error, objArgs) {
    if (objArgs === void 0) { objArgs = {}; }
    return logError(error, objArgs.title, objArgs.message, objArgs.source, objArgs.description);
}
exports.logErrorObj = logErrorObj;
/**
 *
 * @param {*} err The error that need to be serialized
 * @returns {string} A description of the error in the form of JSON
 */
function serializeError(err) {
    var stack = new Error().stack;
    if (!err)
        return JSON.stringify({
            message: "Serialize error recieved an ".concat(err, " error"),
            stack: stack,
        });
    if (lodash_1.default.isString(err))
        return JSON.stringify({ message: err, stack: stack });
    return JSON.stringify(err, getReplaceErrors());
}
exports.serializeError = serializeError;
var getReplaceErrors = function () {
    var seen = new WeakSet();
    return function (key, value) {
        if (value instanceof Error) {
            var error_1 = {};
            Object.getOwnPropertyNames(value).forEach(function (propName) {
                if (typeof value[propName] === 'object' && value[propName] !== null) {
                    if (!seen.has(value[propName])) {
                        return;
                    }
                    seen.add(value[propName]);
                }
                error_1[propName] = value[propName];
            });
            return error_1;
        }
        return value;
    };
};
